// extracted by mini-css-extract-plugin
export var dialog = "sign-up-requirements-modal-module--dialog--d3187";
export var signUpRequirementsModalEnter = "sign-up-requirements-modal-module--sign-up-requirements-modal-enter--24b61";
export var signUpRequirementsModalExit = "sign-up-requirements-modal-module--sign-up-requirements-modal-exit--abcbf";
export var title = "sign-up-requirements-modal-module--title--706c1";